import { PureComponent } from "react";
import classnames from "classnames";
import colors from "/styles/colors";
import PictureComponent from "/components/core/picture/picture-component";
import { trackEvent } from "services/bigbrain-service";
import { THUMBNAIL_LIST_LINK_CLICKED, THUMBNAIL_LIST_BOTTOM_LINK_CLICKED } from "/constants/bigbrain-event-types";
import { StyledBackgroundImageThumbnailItemComponent } from "./background-image-thumbnail-item-component.scss";

export default class BackgroundImageThumbnailItemComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.onButtomLinkClick = this.onButtomLinkClick.bind(this);
  }

  itemClicked = () => {
    const { link } = this.props;
    trackEvent(THUMBNAIL_LIST_LINK_CLICKED, { kind: link });
  };
  onButtomLinkClick(e) {
    const { buttomLink } = this.props;
    trackEvent(THUMBNAIL_LIST_BOTTOM_LINK_CLICKED, { kind: buttomLink });

    e.stopPropagation();
    e.preventDefault();

    window.location.href = buttomLink.url;
  }

  shouldShowHoverDecorator() {
    const { hoverDecorator } = this.props;
    return hoverDecorator && hoverDecorator.show;
  }

  shouldShowButtomLink() {
    const { buttomLink } = this.props;
    return buttomLink && buttomLink.show;
  }

  shouldShowSecondTitle() {
    const { secondTitle } = this.props;
    return secondTitle && secondTitle.text && secondTitle.text.length > 0;
  }

  renderTitle(title) {
    const { text, decorator } = title;
    return (
      <div className="thumbnail-title">
        {text} <span className="thumbnail-title-decorator">{decorator}</span>
      </div>
    );
  }

  render() {
    const { link, firstTitle, secondTitle, subtitle, buttomLink, image, hoverDecorator } = this.props;

    return (
      <StyledBackgroundImageThumbnailItemComponent
        className={classnames("background-image-thumbnail-item-component", {
          "extended-hover-height": this.shouldShowSecondTitle()
        })}
        href={link}
        target="_blank"
        onClick={this.itemClicked}
      >
        <PictureComponent className="image-container" src={image} extraCloudinaryTransformations={{ width: 400 }} />

        {this.shouldShowHoverDecorator() && <div className="hover-decorator-container">{hoverDecorator.text}</div>}

        <div className="text-container">
          <div className="thumbnail-title-wrapper">
            {this.renderTitle(firstTitle)}
            {this.shouldShowSecondTitle() && this.renderTitle(secondTitle)}
          </div>

          <div className="thumbnail-subtitle">{subtitle}</div>

          {this.shouldShowButtomLink() && (
            <div
              className="buttom-link-container"
              onClick={this.onButtomLinkClick}
              style={{ color: colors[buttomLink.color] }}
            >
              {buttomLink.text}
            </div>
          )}
        </div>
      </StyledBackgroundImageThumbnailItemComponent>
    );
  }
}

BackgroundImageThumbnailItemComponent.defaultProps = {
  firstTitle: {}
};
